import React from 'react';
import PropTypes from 'prop-types';
import Badge from '../Badge';
import { getLinkTag } from '../../utils';

import styles from './fullImage.module.scss';

function FullImageCard(props) {
  const {
    badge,
    category,
    image,
    istargetblank,
    link,
    subtitle,
    title,
  } = props;

  const inlineCardStyling = image && image.file ? {
    backgroundImage: `url(${image.file.url})`,
  } : {};

  const linkInformation = getLinkTag(link);
  const Tag = linkInformation.tag || 'div';
  const tagProps = linkInformation.tagProps || {};

  // In case we'll need this, we'll have to add the istargetblank
  // field in the card model in Contentful.
  if (istargetblank && link) {
    tagProps.target = '_blank';
    tagProps.rel = 'noopener noreferrer';
  }

  const cardContent = (
    <div className={styles.card}>
      {image && (
        <div className={styles.image} style={inlineCardStyling} />
      )}

      {badge && (
        <div className={styles.badgeWrapper}>
          <Badge
            badgeType={badge.badgeType}
            text={badge.text}
          />
        </div>
      )}
      <div className={styles.content}>
        {/* This is the card's category, might change in the near future  */}
        {category && (
          <div className={styles.category}>
            <p className={styles.categoryText}>{category}</p>
          </div>
        )}

        {subtitle && (
          <p className={styles.subtitle}>{subtitle}</p>
        )}

        {title && (
          <h3 className={styles.title}>{title}</h3>
        )}
      </div>
    </div>
  );

  return (
    <>
      {(link
        ? (
          <Tag {...tagProps} className={styles.link}>
            {cardContent}
          </Tag>
        )
        : cardContent
      )}
    </>
  );
}

export default FullImageCard;

FullImageCard.propTypes = {
  badge: PropTypes.shape({
    badgeType: PropTypes.string,
    text: PropTypes.string,
  }),
  category: PropTypes.string,
  image: PropTypes.shape({
    file: PropTypes.shape({
      url: PropTypes.string,
    }),
  }),
  istargetblank: PropTypes.bool,
  link: PropTypes.string,
  text: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

FullImageCard.defaultProps = {
  badge: { badgeType: 'primary', text: '' },
  category: '',
  image: { file: { url: '' } },
  istargetblank: false,
  link: '',
  text: '',
  title: '',
  subtitle: '',
};
